import * as types from './mutation-types'

const state = {
  sidebarState: localStorage.getItem('sidebar-state') || '',
  currentPage: {},
}

const getters = {
  getSidebarState(state) {
    return state.sidebarState
  },
  getCurrentPage(state) {
    return state.currentPage
  },
}

const actions = {
  toggleSidebarState({ commit }) {
    commit(types.TOGGLE_SIDEBAR_STATE)
  },
  setCurrentPage({ commit }, currentPage) {
    commit(types.SET_CURRENT_PAGE, { currentPage })
  },
}

const mutations = {
  [types.TOGGLE_SIDEBAR_STATE](state) {
    state.sidebarState = state.sidebarState === '' ? 'minimized' : ''
    localStorage.setItem('sidebar-state', state.sidebarState)
  },
  [types.SET_CURRENT_PAGE](state, { currentPage }) {
    state.currentPage = currentPage
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
